import React, {useState, useEffect} from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import {useSelector, useDispatch} from 'react-redux';
import {filterGroups} from '../../../actions/groups';
import EnhancedTable from '../../common/enhancedTable';
import {groupCols} from '../../../utils/colTypes';
import CustomSnackbar from '../../common/customSnackbar';
import GroupDetail from './detail';
import { getProjects } from '../../../actions/projects';
import { getOnlyAsessors } from '../../../actions/users';

const Groups = (props) => {
  const title = 'Grupos';
  const {page, rowsPerPage, order, orderBy, groups, searchText, sending, dataLength, error, message} = useSelector(state => state.groups);
  const {asessors} = useSelector(state => state.users);
  const [group, setGroup] = useState(null);
  const [isNew, setIsNew] = useState(false);

  const {projects} = useSelector(state => state.projects);


  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(filterGroups(page, rowsPerPage, order, orderBy, searchText));
    dispatch(getProjects());
    dispatch(getOnlyAsessors());
  }, []);

  const onSearch = (searchedText) => {
    dispatch(filterGroups(page, rowsPerPage, order, orderBy, searchedText));
  };

  const onAdd = () => {
    setGroup({});
    setIsNew(true);
  };

  const onDetail = (id) => {
    const groupLocal = groups.filter(obj => obj.id === id)[0];
    setGroup(groupLocal);
    setIsNew(false);
  };

  const handleChangeRowsPerPage = (rowsPerPageLocal) => {
    dispatch(filterGroups(page, rowsPerPageLocal, order, orderBy, searchText));
  };

  const handleChangePage = (pageLocal) => {
    dispatch(filterGroups(pageLocal, rowsPerPage, order, orderBy, searchText));
  };

  const onOrder = (orderLocal, orderByLocal) => {
    dispatch(filterGroups(page, rowsPerPage, orderLocal, orderByLocal, searchText));
  };

  const getEditPermissions = () => {
    const profile = JSON.parse(localStorage.getItem('profile'));
    if (profile) {
      if (profile.permissions.update_profiles) {
        return true;
      }
    }
    return false;
  };

  const getCreatePermission = () => {
    const profile = JSON.parse(localStorage.getItem('profile'));
    if (profile) {
      if (profile.permissions.create_profiles) {
        return true;
      }
    }
    return false;
  };

  const handleGoBack = () => {
    dispatch(filterGroups(page, rowsPerPage, order, orderBy, searchText));
    setGroup(null);
    setIsNew(false);
  };

  const renderSnackBar = () => {
    if (message) {
      return (
        <CustomSnackbar
          variant={error !== null ? 'error' : 'success'}
          message={message}
        />
      );
    }
    return null;
  };

  const isLoading = sending;
  const hasEditPermission = getEditPermissions();
  const hasCreatePermission = getCreatePermission();
  const data = {
    rows: groups,
    cols: groupCols
  };
  const handlers = {
    onDetail,
    onAdd,
    onSearch,
    onOrder,
    onChangePage: handleChangePage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  };
  const config = {
    isDragable: false,
    isSelectable: false,
    hasEditPermission,
    hasCreatePermission,
    isFiterable: false,
    searchText: searchText || '',
    order: {
      by: orderBy,
      direction: order
    },
    pagination: {
      current: page,
      rowsPerPage,
      totalItems: dataLength
    },
    filters: {
      is: false
    }
  };
  return (
    isLoading === true ?
      <CircularProgress style={{position: 'fixed', top: 0, bottom: 0, left: 0, right: 0, margin: 'auto'}} />
      :
      <div>
        {renderSnackBar()}
        {  
          !group ?
            <EnhancedTable
              title={title}
              data={data}
              handlers={handlers}
              config={config}
            />
            :
            <GroupDetail
              group={group}
              asessors={asessors}
              projects={projects}
              handleGoBack={handleGoBack}
              isLoading={isLoading}
              isNew={isNew}
            />
        }
      </div>
  );
};
  
export default Groups;
